import { Component } from '@angular/core';

@Component({
  selector: 'app-tours',
  standalone: true,
  imports: [],
  templateUrl: './tours.component.html',
  styleUrl: './tours.component.scss'
})
export class ToursComponent {

}
